import Chevron from '../Chevron/Chevron'
import ChecklistIcon from '../ChecklistIcon/ChecklistIcon'
import { WHITE } from '../../styles/colors'
import {
  Container,
  ContentContainer,
  StepImage,
  TextContainer,
  TitleText,
  DescriptionText,
  RightContainer,
  CompletedIndicator,
  ChevronContainer
} from './ReferralStepNavigationItem.styles'

interface ReferralStepNavigationItemProps {
  title: string;
  description: string;
  imgUrl: string;
  isCompleted?: boolean;
  onClick?: () => void;
}

const ReferralStepNavigationItem = ({
  title,
  description,
  imgUrl,
  isCompleted,
  onClick
}: ReferralStepNavigationItemProps) => {
  return (
    <Container onClick={onClick}>
      <ContentContainer>
        {imgUrl && <StepImage src={imgUrl} alt={title} />}
        <TextContainer>
          <TitleText>{title}</TitleText>
          <DescriptionText>{description}</DescriptionText>
        </TextContainer>
      </ContentContainer>
      <RightContainer>
        {isCompleted ? (
          <CompletedIndicator>
            <ChecklistIcon
              size={9}
              color={WHITE}
              strokeWidth={2}
            />
          </CompletedIndicator>
        ) : (
          <ChevronContainer>
            <Chevron
              size={12}
              strokeWidth={2.5}
            />
          </ChevronContainer>
        )}
      </RightContainer>
    </Container>
  )
}

export default ReferralStepNavigationItem
